module.exports = __webpack_public_path__ + "static/media/bg.494aa569.svg";